var React = require('react');

function TabletButton (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FFFFFF","d":"M8.487,16.76c4.449-0.267,7.778-4.249,7.508-8.984c-0.245-4.296-4.04-7.897-8.189-7.772\r\n\tC3.399,0.136-0.188,4.167,0.008,8.764C0.21,13.497,3.956,17.03,8.487,16.76z"}));
}

TabletButton.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"16.011px","height":"16.774px","viewBox":"0 0 16.011 16.774","enableBackground":"new 0 0 16.011 16.774","xmlSpace":"preserve"};

module.exports = TabletButton;

TabletButton.default = TabletButton;
